// extracted by mini-css-extract-plugin
export default {"info":"EventEBank_info__7Y7LF","title":"EventEBank_title__IUgEI"};